$(document).ready(function () {
    $("#user_type").on("change", function () {
        let type = $(this).val();

        disableInputs(type);
    })

    if ($("#user_type").val()) {
        let type = $("#user_type").val();

        disableInputs(type);
    }
});

$("#createUserForm").validate({
    rules: {
        phone: {
            required: true,
            validPhone: true
        },
        country_code: {
            required: true,
        },
        email: {
            required: true,
            email: true,
            remote: {
                type: "POST",
                url: window.location.protocol + "//" + window.location.hostname + "/check-email",
            },
            maxlength: 255
        },
    },
    messages: {
        email: {
            remote: "This email already exists"
        }
    },
    submitHandler: function (form) {
        var $btn = $(form).find('button[type="submit"], input[type="submit"]');
        if ($btn.prop('disabled')) {
            return false;
        }
        $btn.prop('disabled', true).addClass('disabled');
        $("#phone_number").val($("#phone").intlTelInput("getNumber"));
        form.submit();
    }
});

$("#editUserForm").validate({
    rules: {
        phone: {
            required: true,
            validPhone: true
        },
        country_code: {
            required: true,
        },
        email: {
            required: true,
            email: true,
            remote: {
                type: "POST",
                url: window.location.protocol + "//" + window.location.hostname + "/check-email",
                data: {
                    user_id: function () {
                        return $("#userId").val();
                    }
                }
            },
            maxlength: 255
        },
    },
    messages: {
        email: {
            remote: "This email already exists"
        }
    },
    submitHandler: function (form) {
        var $btn = $(form).find('button[type="submit"], input[type="submit"]');
        if ($btn.prop('disabled')) {
            return false;
        }
        $btn.prop('disabled', true).addClass('disabled');
        $("#phone_number").val($("#phone").intlTelInput("getNumber"));
        form.submit();
    }
});